import { Redirect, Route } from 'react-router-dom';
import { useAuth } from '.';

export default function AuthRoute({ children, ...rest }: any) {
  const { auth } = useAuth();

  return (
    <Route
      {...rest}
      render={({ location }) =>
        auth ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}
